import { REACT_APP_ENABLE_CODE_VERIFICATION, REACT_APP_URL_V2_OAUTH_TOKEN } from '../components/common/Routes/URLs';
import { getSubject } from '../utils/helpers/jwt';
import { getAccessToken } from '../utils/helpers/sessionStore';
import { BACKEND_IDS } from './ApiConfig';
import { getAuthToken, validateOtpWithOrg } from './AuthService';

const OTP_REQUIRED_CODE = 'TE00';

export const REAUTH_ERRORS = {
  badCredentials: 'com.tempedge.msg.error.badcredentials',
  invalidCode: 'com.tempedge.msg.reauth.invalid_code',
  network: 'com.tempedge.msg.error.networkerror'
};

const readAccessToken = (data) => data?.accessToken || data?.access_token || null;

const readRefreshToken = (data) => data?.refreshToken || data?.refresh_token || null;

const isSameUser = (token) => {
  const currentUser = getSubject(getAccessToken());
  return Boolean(currentUser) && currentUser === getSubject(token);
};

export const getReauthErrorKey = (error, fallbackKey) => {
  if (error?.code === 'ERR_NETWORK') return REAUTH_ERRORS.network;

  const key = error?.response?.data?.errorKey || error?.message;
  return typeof key === 'string' && key.startsWith('com.tempedge.') ? key : fallbackKey;
};

// First half of the login: the password grant. `sameUser` tells whether the token was issued to the user already on screen.
export const requestLoginGrant = async ({ username, password }) => {
  const { data } = await getAuthToken(REACT_APP_URL_V2_OAUTH_TOKEN, { username, password, grant_type: 'password' }, BACKEND_IDS.BACKEND_2);
  const accessToken = readAccessToken(data);

  if (!accessToken) throw new Error(data?.errorKey || REAUTH_ERRORS.badCredentials);
  return {
    sameUser: isSameUser(accessToken),
    accessToken,
    refreshToken: readRefreshToken(data),
    needsOtp: !REACT_APP_ENABLE_CODE_VERIFICATION && (data.code || data.message) === OTP_REQUIRED_CODE
  };
};

// Second half: validates the code (or null when none was asked) for the organization already in use.
export const confirmLoginGrant = async (grant, orgId, otp = null) => {
  const response = await validateOtpWithOrg(otp, orgId, BACKEND_IDS.BACKEND_2, grant.accessToken);
  const accessToken = readAccessToken(response);

  if (!accessToken) throw new Error(response?.errorKey || REAUTH_ERRORS.invalidCode);

  return { accessToken, refreshToken: readRefreshToken(response) || grant.refreshToken };
};
